import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/storage'
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyAGczRbWNDa8lvp9X_Vsck2fabjp9MLMmk',
  authDomain: 'tmna-onescan.firebaseapp.com',
  databaseURL: 'https://tmna-onescan.firebaseio.com',
  projectId: 'tmna-onescan',
  storageBucket: 'tmna-onescan.appspot.com',
  messagingSenderId: '99200559842',
  appId: '1:99200559842:web:35794cc427268898100cbb',
  measurementId: 'G-BJXCK0XJY4'
}
const fireCurrentUser = firebase.getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = firebase.auth().onAuthStateChanged(user => {
            unsubscribe();
            resolve(user);
        }, reject);
    })
};

const firebaseApp = firebase.initializeApp(config)
const auth = firebase.auth()
const analytics = firebase.analytics()
const db = firebase.firestore()
const fs = firebase.storage()
export { firebaseApp, auth, analytics, fs, db, fireCurrentUser }
